import {
    baseUrl,
    urlApiVehicle,
    isSignedIn,
    getHeaders,
} from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";
import { trimPlate } from "@src/utils/datasource.js";

export async function PlateServicesGetPlate(payload) {
    await isSignedIn();

    const newPlate = trimPlate(payload.PlateNumber);
    const query = queryFilter({
        plateNumber: newPlate,
        countryCode: payload.CountryCode,
        lang: payload.LanguageCode,
        accessTipology: 1,
    });

    const urlApi = `${urlApiVehicle}/Vehicle/plate${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function PlateServicesGetNotes() {
    await isSignedIn();

    const query = queryFilter({ showHistory: true });
    const urlApi = `${baseUrl}/TechnicalInformation/Notes/GetNotes${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function PlateServicesPutVehicleToken(body) {
    await isSignedIn();

    const urlApi = `${urlApiVehicle}/Vehicle/token`;

    return axios.put(urlApi, body, getHeaders());
}

export async function PlateServicesGetHistorySearchedPlates() {
    await isSignedIn();

    const urlApi = `${urlApiVehicle}/Vehicle/platesearch/history`;

    return axios.get(urlApi, getHeaders());
}

export async function PlateServicesGetVehicleFieldsDetailsForBackoffice(
    filters
) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${urlApiVehicle}/Vehicle/plate-backoffice${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function PlateServicesVehicleTokenRenewProcessNumber(body) {
    await isSignedIn();

    const urlApi = `${urlApiVehicle}/Vehicle/vehicle-token/renew-processnumber`;

    return axios.put(urlApi, body, getHeaders());
}

export async function PlateServicesVehicleTree(body) {
    await isSignedIn();

    const urlApi = `${urlApiVehicle}/Vehicle/tree`;

    return axios.post(urlApi, body, getHeaders());
}
